export enum DebugLogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export type DebugLogOutputs = {
  console?: boolean;
  localStorage?: boolean;
};

export type DebugLoggerConfig = {
  enabled: boolean;
  outputs?: DebugLogOutputs;
  durationMs?: number;
  expiresAtEpochMs?: number;
  maxEntries?: number;
  label?: string;
};

export type DebugLogEntry = {
  logId: string;
  timstamp: string;
  iso: string;
  level: DebugLogLevel;
  args: any[];
};
